import { API_BASE } from '../../../_CORE/API/_Connection/_ApiBase';

const normalizeRelativeMediaPath = (rawValue) => {
    let value = String(rawValue || '').trim().replace(/\\/g, '/');
    if (!value) return '';

    // Compatibilidad con rutas antiguas que guardaban la carpeta fisica del backend.
    const publicUploads = value.toLowerCase().lastIndexOf('/public/uploads/');
    if (publicUploads >= 0) value = value.slice(publicUploads + '/public'.length);

    value = value.replace(/^\.\//, '/');
    value = value.replace(/^public\/+/i, '/');
    value = value.replace(/^\/?public\/+/i, '/');
    if (!value.startsWith('/')) value = `/${value}`;

    return value.replace(/\/{2,}/g, '/');
};

export const RESOLVE_PORTFOLIO_MEDIA_URL = (value = '') => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) return raw;

    const base = String(API_BASE.STATIC_URL || '').replace(/\/$/, '');
    const path = normalizeRelativeMediaPath(raw);
    return path ? `${base}${path}` : '';
};
